import { apiClient } from "@/lib/http-utils";
import {
  AcceptWorkspaceInvitationDto,
  CreateWorkspaceInvitationDto,
  WorkspaceInvitationResultDto,
} from "@/lib/main-rest-client/definitions";
import { toastError } from "@/lib/utils";
import { userWorkspaceKeys, workspaceKeys } from "@/queries/workspaces";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { toast } from "sonner";

export function useCreateWorkspaceInvitation() {
  return useMutation<
    WorkspaceInvitationResultDto,
    AxiosError,
    CreateWorkspaceInvitationDto
  >({
    mutationFn: async (createWorkspaceInvitationDto) => {
      return (
        await apiClient.createWorkspaceInvitation(createWorkspaceInvitationDto)
      ).data;
    },
    onSuccess: () => {
      toast.success("Invitation created");
    },
  });
}

export function useAcceptWorkspaceInvitaiton() {
  const queryClient = useQueryClient();
  return useMutation<void, AxiosError, AcceptWorkspaceInvitationDto>({
    mutationFn: async (acceptWorkspaceInvitationDto) => {
      return (
        await apiClient.acceptWorkspaceInvitaiton(acceptWorkspaceInvitationDto)
      ).data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: workspaceKeys.all });
      await queryClient.invalidateQueries({ queryKey: userWorkspaceKeys.all });
      toast.success("Invitation accepted");
    },
    onError: (err) => {
      toastError(err);
    },
  });
}
